<template>
  <div>
    <div class="process">
      <div v-bind:style="{width: percent+'%',background:background||'#24bcf4'}"></div>
    </div>
  </div>
</template>
<script>
export default {
    props:['percent',"background"],
  data() {
    return {
      //health: 60,
      eable: false
    };
  },
  methods: {
    
  }
};
</script>
<style lang="">
.process {
  width: 100%;
  height: 10px;
  background: #333;
  vertical-align: bottom;
  border-radius: 10px;
}

.process div {
  height: 10px;
  border-radius: 10px;
}


</style>



// WEBPACK FOOTER //
// src/components/kanban/abc/percent.vue